import { INVOICE_TYPE_LABLE } from './config';
import { getIndexByPropertyValue, checkDataChange } from '@/modules/transport/bms/utils/common.js';
import { isEdit } from '../../utils';
import _ from 'lodash';

export default {
    data() {
        return {
            INVOICE_TYPE_LABLE,
            originalData: [] // 原始数据
        };
    },
    computed: {
        invoiceLabelName: function () {
            return INVOICE_TYPE_LABLE[this.invoiceLabel] || '';
        }
    },
    methods: {
        // 验证是否是新建状态
        isNewState(status) {
            let flag = true;
            if (![10, '10'].includes(status)) {
                this.$message.warning('只有新建状态下的发票才能修改内容，请确认。');
                flag = false;
            }
            return flag;
        },
        // 验证是否是编辑发票头
        isEditHeader() {
            const flag = isEdit('header');
            flag && this.$message.warning('请先保存发票头!');
            return flag;
        },
        // 根据发票标签获取columns
        getColumnsByInvoiceLable(type) {
            type = type ? type.toString() : '';
            const columnMap = this.columnMap || {};
            return _.cloneDeep(columnMap[INVOICE_TYPE_LABLE[type]] || {});
        },
        // 设置按钮loading
        setBtnLoading(eventName, flag) {
            const configItemIndex = getIndexByPropertyValue(this.config.buttonList, 'event', eventName);
            (typeof configItemIndex === 'number') && (this.config.buttonList[configItemIndex].loading = flag);
        },
        // 设置只读
        setReadOnly(flag) {
            this.config.table.selectBtn = flag;
            this.config.table.clickModify = flag;
            this.config.table.leftOperation = flag;
            this.showActionBar && this.showActionBar(flag);
            this.$nextTick(() => {
                if (!flag && this.$refs.tablePage) {
                    // 关闭表格编辑状态
                    this.$refs.tablePage.$refs.table.$refs.mNewTable.EDIT_TYPE.CANCEL = -2;
                    this.$refs.tablePage.$refs.table.$refs.mNewTable.dataInit(this.$refs.tablePage.$refs.table.$refs.mNewTable.tableData);
                }
            });
        },
        // 验证数据是否有修改
        verifyDataModified() {
            return checkDataChange(this.originalData, this.totalData) && this.$message.warning('当前页数据有修改请先保存再切换下一页！');
        },
        // 点击分页的时间处理
        handlePageClick(event) {
            // 数据修改时阻止点击分页事件
            if (this.verifyDataModified()) { event.stopPropagation(); }
        }
    },
    watch: {
        invoiceLabel: {
            immediate: true,
            handler(newValue) {
                this.handleInvoiceLabelWatch && this.handleInvoiceLabelWatch(newValue);
                if (!newValue) return;
                Object.assign(this.$data, this.$options.data());
                const columns = this.getColumnsByInvoiceLable(newValue);
                if (columns instanceof Array) {
                    this.$nextTick(() => {
                        this.$set(this.config.table, 'columns', columns);
                        this.show = true;
                    });
                } else {
                    this.show = false;
                }
            }
        }
    }
};